jQuery(document).ready(function ($) {
  // show mainnav on hover
  $(".ct_navigation .nav-item").hover(function () {
    // remove previously opened dropdowns
    $(this).parent().find(".dropdown-menu").attr("aria-expanded", "false");
    $(this).parent().find(".dropdown-menu").removeClass("show");

    // open current item
    if ($(this).hasClass("dropdown")) {
      $(this).addClass("show");
      $(this).attr("aria-expanded", "true");
      $(this).find(".dropdown-menu").addClass("show");
      $(this).find(".dropdown-menu").attr("aria-expanded", "true");
    }
  });

  $(".ct_navigation").hover(
    function () {},
    function () {
      // close all dropdowns on menu leave
      $(this).removeClass("show");
      $(this).attr("aria-expanded", "false");
      $(this).parent().find(".dropdown-menu").attr("aria-expanded", "false");
      $(this).parent().find(".dropdown-menu").removeClass("show");
    }
  );
});
